import { Nullable } from '@starsoft/common/interfaces';
import { ToggleUserBonusHideInactivesPayload, UserBonusActions } from './props';

export function toggleUserBonusInactive(
  hideInactive: Nullable<boolean>,
): ToggleUserBonusHideInactivesPayload {
  return { type: UserBonusActions.ToggleInactive, payload: hideInactive };
}
